const NETBANKING_MORE_BANKS_PREFIX = "more_banks";

export const NETBANKING_MORE_BANKS_TEST_IDS = {
    CONTAINER: `${NETBANKING_MORE_BANKS_PREFIX}_container`,
    LIST: `${NETBANKING_MORE_BANKS_PREFIX}_list`,
};
